import { render, staticRenderFns } from "./uccFilings.vue?vue&type=template&id=46aa3c2c&scoped=true"
import script from "./uccFilings.vue?vue&type=script&lang=js"
export * from "./uccFilings.vue?vue&type=script&lang=js"
import style0 from "./uccFilings.vue?vue&type=style&index=0&id=46aa3c2c&prod&lang=scss&module=true"
import style1 from "./uccFilings.vue?vue&type=style&index=1&id=46aa3c2c&prod&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "46aa3c2c",
  null
  
)

export default component.exports